import React, { memo, useCallback } from 'react';

import { Stack } from '@mui/material';
import PropTypes from 'prop-types';

import { AiChatTestIds } from '../../../../../AiChat.testIds';
import { ListItemStatus } from '../../../BotMessage.constants';

import { listContainerStyles } from './ListContent.styles';
import { formatListContentCopyText } from './ListContent.utils';
import ListItem from './ListItem';

const ListContent = ({ contentProps, onCopy }) => {
  const handleCopy = useCallback(() => {
    onCopy(formatListContentCopyText(contentProps.listProps));
  }, [contentProps.listProps, onCopy]);

  return (
    <Stack
      data-testid={AiChatTestIds.BOT_MESSAGE_LIST_CONTENT}
      sx={listContainerStyles}
      onClick={handleCopy}
    >
      {contentProps.listProps.map(item => (
        <ListItem
          data-testid={AiChatTestIds.BOT_MESSAGE_LIST_CONTENT_LIST_ITEM}
          item={item}
          key={item.label}
        />
      ))}
    </Stack>
  );
};

ListContent.propTypes = {
  contentProps: PropTypes.shape({
    listProps: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
        status: PropTypes.oneOf(Object.values(ListItemStatus)).isRequired,
      }),
    ).isRequired,
  }).isRequired,
  onCopy: PropTypes.func.isRequired,
};

export default memo(ListContent);
